import { useNavigate } from 'react-router-dom'
import styles from './notificationToast.module.scss'
import { getNotificationIcon, isRiskAlertNotification, getRiskAlertSeverity } from '../../util/notificationIconHelper.js'

export const NotificationToast = ({ notification, onDismiss }) => {
	const navigate = useNavigate()
	const isRiskAlert = isRiskAlertNotification(notification)
	const severity = isRiskAlert ? getRiskAlertSeverity(notification) : null
	const title = isRiskAlert ? 'Risk Alert' : (notification?.type || 'Notification')

	const handleClick = () => {
		if (notification?.link) {
			navigate(notification.link)
		} else {
			navigate('/notifications')
		}
		onDismiss?.()
	}

	const handleDismiss = (e) => {
		e.stopPropagation()
		onDismiss?.()
	}

	const getSeverityClass = () => {
		if (isRiskAlert && severity) return styles[severity] || ''
		return ''
	}

	return (
		<div
			className={`${styles.notificationToast} ${getSeverityClass()}`}
			onClick={handleClick}
			role="button"
			tabIndex={0}
			onKeyDown={(e) => {
				if (e.key === 'Enter' || e.key === ' ') {
					handleClick()
				}
			}}
		>
			{/* Icon */}
			<div className={styles.iconContainer}>
				{getNotificationIcon(notification)}
			</div>

			{/* Content */}
			<div className={styles.content}>
				<div className={styles.header}>
					<span className={styles.title}>{title}</span>
					<button
						className={styles.dismissBtn}
						onClick={handleDismiss}
						aria-label="Dismiss notification"
					>
						×
					</button>
				</div>
				<p className={styles.message}>{notification?.message ?? ''}</p>
			</div>
		</div>
	)
}
